<template>
  <footer class="main-footer-wrapper">
    <div class="main-footer-container" v-if="!$isMobile">
      <div class="main-footer-content">
        <div class="logo-title-container">
          <div class="logo-container" @click="scrollToTopBlock">
            <img :src="getUrlLogo('logo-big')" alt="logo">
          </div>
          <big-paragraph>
            {{ textBottom }}
          </big-paragraph>
          <media-block :is-active-dark="true"/>
        </div>
        <div class="info-container">
          <div class="navigation-info-container">
            <main-paragraph v-for="item in navigationInfo"
                            :color="'purple-grey'"
                            @click="scrollToBlock(item)">
              {{ item.text }}
            </main-paragraph>
          </div>
          <div class="contact-info-container">
            <contact-title v-for="item in contactInfo"
                           :key="item.id"
                           :info="item"/>
          </div>
        </div>
      </div>
      <div class="bottom-container">
        <sub-paragraph>
          {{ yearTitle }}
        </sub-paragraph>
        <div class="btns-container">
          <router-link to="/policy" target="_blank">
            <sub-paragraph>
              {{ btnBottom }}
            </sub-paragraph>
          </router-link>
        </div>
      </div>
    </div>
    <div class="main-footer-container" v-else>
      <div class="main-footer-content">
        <div class="logo-container" @click="scrollToTopBlock">
          <img :src="getUrlLogo('logo-dark-mini')" alt="logo">
        </div>
        <div class="contact-info-container">
          <contact-title v-for="item in contactInfo"
                         :key="item.id"
                         :info="item"/>
        </div>
        <div class="navigation-info-container">
          <main-paragraph v-for="item in navigationInfo"
                          :color="'purple-grey'"
                          @click="scrollToBlock(item)">
            {{ item.text }}
          </main-paragraph>
        </div>
        <big-paragraph class="title-container">
          {{ textBottom }}
        </big-paragraph>
        <media-block :is-active-dark="true"/>
      </div>
      <div class="bottom-container">
        <sub-paragraph>
          {{ yearTitle }}
        </sub-paragraph>
        <div class="btns-container">
          <router-link to="/policy" target="_blank">
            <sub-paragraph>
              {{ btnBottom }}
            </sub-paragraph>
          </router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import SubParagraph from "@/components/shared/text/SubParagraph.vue";
import BigParagraph from "@/components/shared/text/BigParagraph.vue";
import MainParagraph from "@/components/shared/text/MainParagraph.vue";
import MediaBlock from "@/components/entities/MediaBlock.vue";
import ContactTitle from "@/components/shared/ContactTitle.vue";

export default {
  name: "MainFooter",
  components: {ContactTitle, MediaBlock, MainParagraph, BigParagraph, SubParagraph},
  data() {
    return {
      contactInfo: [
        {
          id: 0,
          title: '129085, Москва,  ул. Годовикова, 9 стр.1',
          type: 'location'
        },
        {
          id: 1,
          title: 'Пн - Пт:\n8:00 до 17:00 ',
          type: 'time'
        },
        {
          id: 2,
          title: '+7 (499) 703 02 64',
          type: 'phone'
        },
        {
          id: 3,
          arrTitle: [
            {
              title: 'Отдел продаж:',
              text: 'sales@avea-basis.ru'
            },
            {
              title: 'Отдел кадров:',
              text: 'shehova@avea-technology.com'
            },
            {
              title: 'По административным вопросам:',
              text: 'info@avea-technology.com'
            }
          ],
          type: 'mail',
        }
      ],
      textBottom: 'Единственный в России производитель оснастки мирового уровня',
      btnBottom: 'Политика конфиденциальности'
    }
  },
  computed: {
    yearTitle() {
      return `©${new Date().getFullYear()} AVEA`
    },
    navigationInfo() {
      return this.navigationStatic.filter(item => !item?.isActiveOnlyHeader);
    }
  }
}
</script>

<style scoped lang="scss">
  .main-footer-wrapper {
    width: 100%;
    .main-footer-container {
      width: 100%;
      max-width: var(--main-max-width);
      padding: 0 var(--var-padding);
      display: flex;
      flex-direction: column;
      margin: 0 auto;
      .main-footer-content {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .logo-title-container {
          display: flex;
          flex-direction: column;
          .text-content {
            color: var(--color-purple-grey);
          }

          .logo-container {
            margin-bottom: auto;
            cursor: pointer;
            width: 100%;
            & img {
              object-fit: contain;
              width: 100%;
              height: 100%;
            }
          }
        }
        .info-container {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .navigation-info-container {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .text-content {
              cursor: pointer;
              white-space: nowrap;
              transition: opacity .6s ease;

              &:hover {
                opacity: .5;
              }
            }
          }
          .contact-info-container {
            display: flex;
            flex-direction: column;
          }
        }
      }
      .bottom-container {
        border-top-style: solid;
        border-top-color: rgba(var(--color-grey-rgba), .5);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .text-content {
          color: var(--color-grey);
        }
        .btns-container {
          display: flex;
          flex-direction: row;
          .text-content {
            cursor: pointer;
            transition: all .3s ease;
            &:hover {
              color: var(--color-white);
            }
          }
        }
      }
    }
  }

  @media (max-width: 3024px){
    .main-footer-wrapper {
      .main-footer-container {
        .main-footer-content {
          padding: 160px 0;
          column-gap: 170px;
          .logo-title-container {
            min-width: 580px;
            width: 0;

            .media-container {
              margin-top: 30px;
            }

            .logo-container {
              max-width: 580px;
            }
          }
          .info-container {
            column-gap: 120px;
            .navigation-info-container {
              width: 330px;
              row-gap: 65px;

              .text-content {
                font-size: 24px;
              }
            }

            .contact-info-container {
              max-width: 574px;
              row-gap: 50px;
            }
          }
        }
        .bottom-container {
          border-top-width: 1px;
          padding: 71px 0;
          .btns-container {
            column-gap: 48px;
          }
        }
      }
    }
  }


  @media (max-width: 1920px) {

    .main-footer-wrapper {
      .main-footer-container {
        .main-footer-content {
          padding: 120px 0;
          column-gap: 280px;
          .logo-title-container {
            min-width: 500px;
            width: 0;

            .media-container {
              margin-top: 30px;
            }

            .logo-container {
              max-width: 500px;
            }
          }
          .info-container {
            column-gap: 78px;
            .navigation-info-container {
              width: 240px;
              row-gap: 48px;

              .text-content {
                font-size: 20px;
              }
            }

            .contact-info-container {
              max-width: 442px;
              row-gap: 32px;
            }
          }
        }
        .bottom-container {
          border-top-width: 1px;
          padding: 40px 0;
          .btns-container {
            column-gap: 48px;
          }
        }
      }
    }
  }
  @media (max-width: 1600px) {

    .main-footer-wrapper {
      .main-footer-container {
        .main-footer-content {
          padding: 120px 0 100px;
          column-gap: 200px;
          .logo-title-container {
            min-width: 399px;
            width: 0;

            .media-container {
              margin-top: 24px;
            }

            .logo-container {
              max-width: 357px;
            }
          }
          .info-container {
            column-gap: 108px;
            .navigation-info-container {
              width: 167px;
              row-gap: 34px;

              .text-content {
                font-size: 14px;
              }
            }

            .contact-info-container {
              max-width: 306px;
              row-gap: 24px;
            }
          }
        }
        .bottom-container {
          border-top-width: 1px;
          padding: 30px 0;
          .btns-container {
            column-gap: 48px;
          }
        }
      }
    }
  }
  @media (max-height: 800px) {


    .main-footer-wrapper {
      .main-footer-container {
        .main-footer-content {
          padding: 80px 0;
          column-gap: 200px;
          .logo-title-container {
            min-width: 340px;
            width: 0;

            .media-container {
              margin-top: 24px;
            }

            .logo-container {
              max-width: 316px;
            }
          }
          .info-container {
            column-gap: 89px;
            .navigation-info-container {
              width: 167px;
              row-gap: 34px;

              .text-content {
                font-size: 12px;
              }
            }

            .contact-info-container {
              max-width: 264px;
              row-gap: 16px;
            }
          }
        }
        .bottom-container {
          border-top-width: 1px;
          padding: 20px 0;
          .btns-container {
            column-gap: 48px;
          }
        }
      }
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {


    .main-footer-wrapper {
      .main-footer-container {
        .main-footer-content {
          padding: 120px 0 100px;
          column-gap: 200px;
          .logo-title-container {
            min-width: 399px;
            width: 0;

            .media-container {
              margin-top: 24px;
            }

            .logo-container {
              max-width: 357px;
            }
          }
          .info-container {
            column-gap: 108px;
            .navigation-info-container {
              width: 167px;
              row-gap: 34px;

              .text-content {
                font-size: 14px;
              }
            }

            .contact-info-container {
              max-width: 306px;
              row-gap: 24px;
            }
          }
        }
        .bottom-container {
          border-top-width: 1px;
          padding: 30px 0;
          .btns-container {
            column-gap: 48px;
          }
        }
      }
    }
  }

  @media (max-width: 1133px) {
    .main-footer-wrapper {
      .main-footer-container {
        .main-footer-content {
          padding: 80px 0;
          column-gap: 200px;
          .logo-title-container {
            min-width: 340px;
            width: 0;

            .media-container {
              margin-top: 24px;
            }

            .logo-container {
              max-width: 316px;
            }
          }
          .info-container {
            column-gap: 89px;
            .navigation-info-container {
              width: 167px;
              row-gap: 34px;

              .text-content {
                font-size: 12px;
              }
            }

            .contact-info-container {
              max-width: 264px;
              row-gap: 16px;
            }
          }
        }
        .bottom-container {
          border-top-width: 1px;
          padding: 20px 0;
          .btns-container {
            column-gap: 48px;
          }
        }
      }
    }
  }
  @media (max-width: 769px) {
    .main-footer-wrapper {
      .main-footer-container {
        .main-footer-content {
          padding: 48px 0;
          display: flex;
          flex-direction: column;
          row-gap: 52px;
          .logo-container {
            width: 100%;
            & img {
              width: 100%;
              height: 100%;
            }
          }
          .contact-info-container {
            display: flex;
            flex-direction: column;
            row-gap: 16px;
          }
          .navigation-info-container {
            display: flex;
            flex-direction: column;
            row-gap: 34px;
            flex-wrap: wrap;
            max-height: 158px;
          }

          .title-container {
            color: var(--color-purple-grey);
            margin-bottom: -28px;
          }
        }
      }
    }
    //iPhone 14
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //iPhone Plus
  }
  @media (min-height: 600px) and (max-height: 630px){
    //для экранов 8 плюс
  }

  @media (max-width: 375px){
    //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
    //iPhone X
  }


  @media (max-width: 320px) {
    //iPhone SE
  }

  @media (min-width: 3025px) {

    .main-footer-wrapper {
      .main-footer-container {
        .main-footer-content {
          padding: 300px 0;
          column-gap: 320px;
          .logo-title-container {
            min-width: 1080px;
            width: 0;


            .media-container {
              margin-top: 80px;
            }


            .logo-container {
              max-width: 975px;
            }
          }
          .info-container {
            column-gap: 40px;
            .navigation-info-container {
              width: 1080px;
              column-gap: 48px;
              row-gap: 48px;
            }
            .contact-info-container {
              max-width: 1080px;
              row-gap: 80px;
            }
          }
        }
        .bottom-container {
          border-top-width: 1px;
          padding: 71px 0;
          .btns-container {
            column-gap: 48px;
          }
        }
      }
    }
  }

</style>